import React, { useEffect, useState } from "react";
import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    tooltip: {
        fontWeight: 400,
        // maxWidth: 500,
        padding: theme.spacing(2, 4),
        backgroundColor: "#616161",
        color: "#FFFFFF",
        boxShadow: "1px 1px 1px 0px #00000011, 2px 8px 32px -8px #00000033",
    },
}));

const AccessibilityTooltip = (props) => {
    const { onKey, forceHide = false, forceOpen = false, children, clean, classes, ...rest } = props;

    const internalClasses = useStyles();

    const [open, setOpen] = useState(false);

    const handleEsc = (event) => {
        if (event.key === "Escape") {
            setOpen(false);
        }
    };

    useEffect(() => {
        if (onKey === 27) setOpen(false);
    }, [onKey]);

    useEffect(() => {
        if (forceHide) setOpen(false);
    }, [forceHide]);

    useEffect(() => {
        if (forceOpen) setOpen(true);
    }, [forceOpen]);

    useEffect(() => {
        window.addEventListener("keydown", handleEsc);
    }, []);

    return (
        <Tooltip
            {...rest}
            classes={{ tooltip: internalClasses.tooltip, ...classes }}
            open={open}
            onOpen={() => (forceHide ? setOpen(false) : setOpen(true))}
            onClose={() => (forceOpen ? setOpen(true) : setOpen(false))}
            interactive
        >
            {clean ? children : <div>{children}</div>}
        </Tooltip>
    );
};

export default AccessibilityTooltip;
